/* global hcaptcha */
// The catcha on this page is invisible, use the GoogleBot useragent to debug it.
import * as Sentry from "@sentry/browser";

const hCaptchas = {}; // Stores the hCaptchas
const created_trainee_form_selector = "#created_trainee_form";

document.addEventListener("DOMContentLoaded", function () {
  const createdTraineeForm = document.querySelector(created_trainee_form_selector);
  if (!createdTraineeForm) return;

  const captchaSpots = [...createdTraineeForm.querySelectorAll(".js-h-captcha-spot")];
  if (captchaSpots.length === 0) return;

  bindFormSubmit(createdTraineeForm);
  createHCaptchas(captchaSpots);
});

const submit = () => {
  document.querySelector(created_trainee_form_selector).submit();
};

function createHCaptchas(captchaSpots) {
  if (!window.hcaptcha) {
    return setTimeout(() => createHCaptchas(captchaSpots), 500);
  }

  captchaSpots.forEach(function (div) {
    const siteKey = div.getAttribute("data-sitekey");
    const callback = div.getAttribute("data-callback");
    const size = div.getAttribute("data-size");
    const formId = div.getAttribute("data-form-id");

    let widgetID = hcaptcha.render(`hcaptcha-${formId}`, { sitekey: siteKey, callback: callback, size: size });
    hCaptchas[formId] = widgetID;
  });
}

function bindFormSubmit(form) {
  if (!form) {
    return;
  }

  form.addEventListener(
    "submit",
    (e) => {
      e.preventDefault();
      form.querySelectorAll("button[type='submit']").forEach((button) => (button.disabled = true));
      hcaptcha.execute(hCaptchas[form.id]);

      const iframe = document.querySelector('iframe[src*="hcaptcha.com"]:not([aria-hidden="true"])');
      if (!iframe) {
        Sentry.captureException(new Error("Could not find HCaptcha iframe, did the API change?"));
        return;
      }

      const hcaptchaUiRoot = iframe?.parentNode?.parentNode;
      const hcaptchaBackground = hcaptchaUiRoot?.querySelector('div[style*="position: fixed"]');
      if (!hcaptchaBackground) {
        Sentry.captureException(new Error("Could not find HCaptcha background, did the API change?"));
        return;
      }

      hcaptchaBackground.addEventListener("click", () => {
        bindFormSubmit(form);
        form.querySelectorAll("button[type='submit']").forEach((button) => (button.disabled = false));
      });
    },
    { once: true }
  );
}

window.onRegistrationPublicSubmit = () => submit();
